import { Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { UiService } from '@shared/ui';
import { NotificacionesComponent } from '../notificaciones/notificaciones.component';
import { YaloAppsComponent } from '../yalo-apps/yalo-apps.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  constructor(
    public readonly ui: UiService,
    private popoverController: PopoverController
  ) { }

  ngOnInit() { }

  async presentNotifications(event: any) {
    const notifications = await this.popoverController.create({
      component: NotificacionesComponent,
      cssClass: 'notifications-popover',
      event,
      showBackdrop: false,
      backdropDismiss: true,
    });
    await notifications.present();
  }

  async presentYaloApps(event: any) {
    const yaloApps = await this.popoverController.create({
      component: YaloAppsComponent,
      cssClass: 'default-popover',
      event,
      showBackdrop: false,
      backdropDismiss: true,
    });
    await yaloApps.present();
  }
}
